import React from 'react';
import { motion } from 'framer-motion';

const CallToAction = () => {
  return (
    <section id="cta" className="section bg-white">
      <div className="container mx-auto">
        <div className="bg-gradient-to-r from-purple-si to-purple-light-si rounded-2xl overflow-hidden shadow-xl">
          <div className="px-6 py-12 md:p-12">
            <div className="text-white text-center max-w-3xl mx-auto">
              <h2 className="text-3xl md:text-4xl font-bold mb-4">
                Add Sales Intercept Risk Free
              </h2>
              <p className="text-lg md:text-xl opacity-90 mb-6">
                No credit card required to begin. Try it out on your website to see the results before buying.
              </p>
              <div className="flex flex-wrap gap-4 justify-center">
                <motion.a
                  href="https://dashboard.salesintercept.com/signup" 
                  className="btn bg-white text-purple-si hover:bg-white/90 focus:ring-white"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  Start Free Trial
                </motion.a>
              </div>
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="mt-20">
          <h3 className="text-2xl md:text-3xl font-bold text-center mb-8">
            Frequently Asked Questions
          </h3>
          
          <div className="max-w-3xl mx-auto space-y-6">
            <div className="bg-gray-50 rounded-lg p-6">
              <h4 className="text-lg font-bold mb-2">How difficult is it to install Sales Intercept?</h4>
              <p className="text-gray-700">
                It's incredibly simple! Just add a single line of code to your website header, 
                similar to adding Google Analytics. No technical expertise required.
              </p>
            </div>
            
            <div className="bg-gray-50 rounded-lg p-6">
              <h4 className="text-lg font-bold mb-2">How long does setup take?</h4>
              <p className="text-gray-700">
                Most users go live in under five minutes with a single line of code.
              </p>
            </div>
            
            <div className="bg-gray-50 rounded-lg p-6">
              <h4 className="text-lg font-bold mb-2">Will Sales Intercept slow down my website?</h4>
              <p className="text-gray-700">
                Not at all. Sales Intercept is optimized for performance and loads asynchronously, 
                so it won't impact your page load times or user experience.
              </p>
            </div>
            
            <div className="bg-gray-50 rounded-lg p-6">
              <h4 className="text-lg font-bold mb-2">How long is your free trial?</h4>
              <p className="text-gray-700">
                Your free trial is 14 days. More than enough time to add videos to your website and get an idea of how it is working for you.
              </p>
            </div>

            <div className="bg-gray-50 rounded-lg p-6">
              <h4 className="text-lg font-bold mb-2">What if I need more than three video uploads?</h4>
              <p className="text-gray-700">
                We've got you covered. If you need more than three videos, we're happy to accommodate. 
                During your free trial, we'll work with you to build a custom plan that fits your content needs.
              </p>
            </div>
          </div>

          <div className="text-center mt-8 space-y-2">
            <p className="text-gray-700">
              Still have more questions before getting started? Feel free to send us an email at{' '}
              <a href="mailto:contact@salesintercept.com" className="text-purple-si hover:text-purple-si/90">
                contact@salesintercept.com
              </a>
            </p>
            <p className="text-gray-700">
              Call or Text us at (716) 508-0295
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;